import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@commenda/kakashi';
import { useCallback, useEffect, useState } from 'react';
import { JsonSchemaBuilder } from '../SchemaBuilderApp';

export const JsonSchemaEditorModal = ({
  isOpen,
  onClose,
  jsonSchema,
  setJsonSchema,
  title,
  showAdditionalProperties = false,
}: {
  isOpen: boolean;
  onClose: () => void;
  jsonSchema: Record<string, any>;
  setJsonSchema: (jsonSchema: Record<string, any>) => void;
  title?: string;
  showAdditionalProperties?: boolean;
}) => {
  const [currentSchema, setCurrentSchema] =
    useState<Record<string, unknown>>(jsonSchema);

  const handleSchemaChange = useCallback(
    (schema: Record<string, unknown>) => setCurrentSchema(schema),
    []
  );

  useEffect(() => {
    if (isOpen) setCurrentSchema(jsonSchema);
  }, [isOpen, jsonSchema]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="w-full max-w-4xl max-h-[90vh] flex flex-col overflow-hidden">
        <DialogHeader className="flex-shrink-0">
          <DialogTitle>{title || 'Edit JSON Schema'}</DialogTitle>
        </DialogHeader>

        <div className="flex-grow overflow-y-auto min-h-0">
          <JsonSchemaBuilder
            initialJsonSchema={jsonSchema}
            setJsonSchema={setJsonSchema}
            showAdditionalProperties={showAdditionalProperties}
            hideUpdateButton
            onSchemaChange={handleSchemaChange}
          />
        </div>

        <DialogFooter className="flex-shrink-0">
          <Button size="md" onClick={() => setJsonSchema(currentSchema)}>
            Update
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
